/**
 * App route paths — single source of truth for hardcoded navigation strings.
 *
 * Use these constants with `navigate()` / links instead of inlining the literal
 * path, so a route rename is a one-line change. Migrate existing hardcoded
 * occurrences to these opportunistically (there are ~20 of `/app/s/subscription-plan`
 * across the codebase as of this writing).
 */

/** Native Settings → Subscription Plan page (`/app/s/subscription-plan`). */
export const SUBSCRIPTION_PLAN_PATH = '/app/s/subscription-plan';

/** Settings → Account Members page (`/app/s/account-members`). */
export const ACCOUNT_MEMBERS_PATH = '/app/s/account-members';
